import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import Star01Icon from '@untitled-ui/icons-react/build/esm/Star01';
import DotsVerticalIcon from '@untitled-ui/icons-react/build/esm/DotsVertical';
import Globe01Icon from '@untitled-ui/icons-react/build/esm/Globe03';
import InfoIcon from '@mui/icons-material/Info';
import {
  Avatar,
  AvatarGroup,
  Box,
  Card,
  Divider,
  IconButton,
  Stack,
  SvgIcon,
  Tooltip,
  Typography
} from '@mui/material';
import { usePopover } from 'src/hooks/use-popover';
import { bytesToSize } from 'src/utils/bytes-to-size';
import { ItemIcon } from './item-icon';
// import { ItemMenu } from './item-menu';
import { minHeight } from '@mui/system';
import { useNavigate } from 'react-router';

export const ItemListCard = (props) => {
  const { item, onDelete, onFavorite, onOpen } = props;
  const popover = usePopover();
  const navigate = useNavigate();
  const handleDelete = useCallback(() => {
    popover.handleClose();
    onDelete?.(item.id);
  }, [item, popover, onDelete]);

  const redirectEdit = (data) => {
    navigate(`/calculators/${data.id}/details`)
  }

  // let size = bytesToSize(item.size);

  // if (item.type === 'folder') {
  //   size += `• ${item.itemsCount} items`;
  // }

  const created_at = item.created_at && format(item.created_at, 'MMM dd, yyyy');
  const showShared = !item.isPublic && (item.shared || []).length > 0;

  return (
    <>
      <Card
        key={item.id}
        sx={{
          backgroundColor: 'transparent',
          boxShadow: 0,
          transition: (theme) => theme.transitions.create(['background-color, box-shadow'], {
            easing: theme.transitions.easing.easeInOut,
            duration: 200
          }),
          '&:hover': {
            backgroundColor: 'background.paper',
            boxShadow: 16
          },
          margin:'10px',
          cursor:'pointer'
        }}
        variant="outlined"
        onClick={() => redirectEdit(item)}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="end"
          spacing={3}
          sx={{
            pt: 6,
            px: 5,
            backgroundImage: 'url(assets/cards/calculator-card.jpg)',
          }}
        >
          {/* <IconButton onClick={() => onFavorite?.(item.id, !item.isFavorite)}>
            <SvgIcon
              fontSize="small"
              sx={{ color: item.isFavorite ? 'warning.main' : 'action.active' }}
            >
              <Star01Icon />
            </SvgIcon>
          </IconButton> */}
          {/* <IconButton
            onClick={popover.handleOpen}
            ref={popover.anchorRef}
          >
            <SvgIcon fontSize="small">
              <DotsVerticalIcon />
            </SvgIcon>
          </IconButton> */}
        </Stack>
        <Box sx={{ p: 2 }}>
          <Box
            sx={{
              display: 'flex',
              mb: 1,
            }}
          >
            <Box
              onClick={() => onOpen?.(item.id)}
              sx={{
                display: 'inline-flex',
                cursor: 'pointer',
                position: 'relative',
              }}
            >
              <ItemIcon
                type={item.type}
                extension={item.extension}
                className={'calculator-card-icon'}
                sx={{position:'absolute', top: '-50px'}}
              />
            </Box>
          </Box>
          <Typography
            onClick={() => onOpen?.(item.id)}
            sx={{ cursor: 'pointer' }}
            variant="subtitle2"
          >
            {item.name}
          </Typography>
          <Divider sx={{ my: 1 }} />
          <Stack
            alignItems="center"
            direction="row"
            justifyContent="space-between"
            spacing={1}
          >
            <div>
              <Typography
                color="text.primary"
                variant="h6"
              >
                {item.title}
              </Typography>
              <Typography
                color="text.secondary"
                variant="body2"
              >
                {item.sub_title}
              </Typography>
            </div>
            <div>
              {item.isPublic && (
                <Tooltip title={item.description}>
                  <Avatar
                    sx={{
                      height: 32,
                      width: 32
                    }}
                  >
                    <SvgIcon fontSize="small">
                      <InfoIcon />
                    </SvgIcon>
                  </Avatar>
                </Tooltip>
              )}
              {showShared && (
                <AvatarGroup max={3}>
                  {item.shared?.map((person) => (
                    <Avatar
                      key={person.name}
                      src={person.avatar}
                      sx={{
                        height: 32,
                        width: 32
                      }}
                    />
                  ))}
                </AvatarGroup>
              )}
            </div>
          </Stack>
          <Typography
            color="text.secondary"
            variant="caption"
          >
            Created at {created_at}
          </Typography>
        </Box>
      </Card>
      {/* <ItemMenu
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        onDelete={handleDelete}
        open={popover.open}
        data={item}
      /> */}
    </>
  );
};

ItemListCard.propTypes = {
  item: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
  onFavorite: PropTypes.func,
  onOpen: PropTypes.func
};
